export default "__VITE_ASSET__C$npaWfU__"